define('views/components/customer_manager/customer_manager',['require','backbone','text!templates/components/customer_manager/customer_manager.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/customer_manager/customer_manager.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'customer-manager-item'
    });
});
